import { render, staticRenderFns } from "./LegalMinimumWagePage.vue?vue&type=template&id=69a54412&scoped=true"
import script from "./LegalMinimumWagePage.vue?vue&type=script&lang=js"
export * from "./LegalMinimumWagePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a54412",
  null
  
)

export default component.exports